import { render, staticRenderFns } from "./Dashboard_LO.vue?vue&type=template&id=2b279fac&scoped=true&"
import script from "./Dashboard_LO.vue?vue&type=script&lang=js&"
export * from "./Dashboard_LO.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard_LO.vue?vue&type=style&index=0&id=2b279fac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b279fac",
  null
  
)

export default component.exports